import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import axios from 'axios';
import { getSiteKey } from '../../components/RecaptchaProvider/RecaptchaProvider.utils';
import { getBusinessTypePath } from '../../utils/api';
import { isValidEmail } from '../../utils/strings';
export function createContact(_x, _x2, _x3, _x4) {
  return _createContact.apply(this, arguments);
}
function _createContact() {
  _createContact = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(businessId, businessType, locationId, recaptchaToken) {
    var formData,
      headers,
      url,
      fullUrl,
      payload,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          formData = _args.length > 4 && _args[4] !== undefined ? _args[4] : {};
          headers = {};
          url = process.env.SERVER_URL || process.env.STORYBOOK_SERVER_URL;
          fullUrl = "".concat(url, "businesses/").concat(getBusinessTypePath(businessType), "/").concat(businessId, "/locations/").concat(locationId, "/contacts/create/");
          payload = _objectSpread(_objectSpread({}, formData), {}, {
            'recaptcha-token': recaptchaToken,
            'recaptcha-site-key': getSiteKey()
          });
          return _context.abrupt("return", axios.post(fullUrl, payload, {
            headers: headers
          }));
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _createContact.apply(this, arguments);
}
export function getErrors() {
  var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var formData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var errors = {};
  fields.forEach(function (field) {
    var key = field.key;
    var value = formData[key];
    if (!value) {
      errors[key] = 'Please enter a valid value';
    }
    if (key === 'email' && !isValidEmail(value)) {
      errors[key] = 'Please enter a valid email';
    }
  });
  return errors;
}